// Bug 34956: profile photos live in the Sparta "profile-photo" folder, named
// `${hrRef}_profile_photo_${originalName}`. Callers used to pick an employee's photo with
// `name.includes(hrRef)`, so hrRef 1827 also matched 18277's photo (both exist in prod) or an upload
// called IMG_1827.jpg, and the badge upload/delete then deleted those other employees' photos.
// Match on the exact prefix instead.

const PROFILE_PHOTO_INFIX = '_profile_photo_';

/** The stored name for an employee's profile photo. */
export function profilePhotoFileName(
  hrRef: number | string,
  originalName: string
): string {
  return `${hrRef}${PROFILE_PHOTO_INFIX}${originalName}`;
}

/** True only when the file is this employee's profile photo (exact hrRef prefix). */
export function isProfilePhotoFor(
  name: string | null | undefined,
  hrRef: number | string | null | undefined
): boolean {
  if (!name || hrRef === null || hrRef === undefined || `${hrRef}` === '') {
    return false;
  }

  return name.startsWith(`${hrRef}${PROFILE_PHOTO_INFIX}`);
}
